module.exports = __webpack_public_path__ + "static/media/yamini.724523ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/yamini.jpg
// module id = 1280
// module chunks = 0